const UNITS_DICT = {
  days: 'timeUnits.dayWithCount',
  hours: 'timeUnits.hourWithCount',
  mins: 'timeUnits.minuteWithCount',
};

const MAX_NUM_OF_UNITS = 2;

export function getDeltaMsg(deltaTime: {
  days: number;
  hours: number;
  mins: number;
}): [number, string][] {
  const result = Object.entries(deltaTime).map(([units, value]) => {
    const dictUnits = UNITS_DICT[units as keyof typeof UNITS_DICT];
    return [Math.abs(value), dictUnits];
  });

  return result.filter((item) => item[0] !== 0).slice(0, MAX_NUM_OF_UNITS) as [
    number,
    string,
  ][];
}
